import React from 'react';
import { styled } from '@mui/system';
import { useLocation, Navigate } from 'react-router-dom';
import Loading from '../../components/ui/Loading';
import Note from './components/Note';
import { useGetNoteInfoQuery } from '../../store/api/noteApi';
import NotesCardGroup from '../../components/shared/RelatedNoteSection/NotesCardGroup';
import { extractIdFromURL } from '../../utils/common';
import { DEFAULT_NOTE } from '../../utils/constant';

const NotePageContainer = styled('div')(({ theme }) => ({
  padding: '30px',
  width: '100%',
  [theme.breakpoints.down('750')]: {
    padding: '0',
  },
}));

const NotePage = () => {
  const location = useLocation();
  const id = extractIdFromURL(location.pathname)
    ? extractIdFromURL(location.pathname)
    : DEFAULT_NOTE;

  const { data: note, isLoading } = useGetNoteInfoQuery(id);
  if (isLoading) return <Loading />;
  if (!note) return <Navigate to="/notfound" replace />;

  return (
    <NotePageContainer>
      <Note noteData={note.data} />
      <NotesCardGroup
        displayName="related Cafe & Food:)"
        noteCardData={note.data.relatedCafes[0]?.relatedNotes}
        typeofTitle="More notes on"
      />
    </NotePageContainer>
  );
};

export default NotePage;
